<template>
    <a v-if="hasHref" :class="buttonClasses" :href="href" :disabled="disabled" class="mds-button" @click="buttonClickHandler">
        <mds-icon v-if="hasLeftIcon" :name="icon" :class="iconClasses" class="mds-button__icon--left"> </mds-icon>
        <span class="mds-button__text">
            <slot v-bind:text="text">{{ text }}</slot>
        </span>
        <mds-icon v-if="hasRightIcon" :name="iconRight" :class="iconClasses" class="mds-button__icon--right"> </mds-icon>
    </a>
    <label v-else-if="this.isCheckBox || this.isRadio" class="mds-button__input-outer-wrapper">
        <mds-input
            :type="type"
            :id="id"
            :name="name"
            :value="value"
            :disabled="disabled"
            :checked="checked"
            class="mds-button__input"
            @click="buttonClickHandler"
        ></mds-input>
        <span :for="id" class="mds-button" :class="buttonClasses">
            <mds-icon v-if="hasLeftIcon" :name="icon" :class="iconClasses" class="mds-button__icon--left"> </mds-icon>
            <span class="mds-button__text">
                <slot v-bind:text="text">{{ text }}</slot>
            </span>
            <mds-icon v-if="hasRightIcon" :name="iconRight" :class="iconClasses" class="mds-button__icon--right"> </mds-icon>
        </span>
    </label>
    <button v-else :type="type" :class="buttonClasses" :disabled="disabled" :aria-label="ariaLabel" class="mds-button" @click="buttonClickHandler">
        <mds-icon v-if="hasLeftIcon" :name="icon" :class="iconClasses" class="mds-button__icon--left"> </mds-icon>
        <template v-if="!isIconOnly">
            <template v-if="hasIcon">
                <span class="mds-button__text">
                    <slot v-bind:text="text">{{ text }}</slot>
                </span>
            </template>
            <template v-else>
                <slot v-bind:text="text">{{ text }}</slot>
            </template>
        </template>
        <mds-icon v-if="hasRightIcon && !isIconOnly" :name="iconRight" :class="iconClasses" class="mds-button__icon--right"> </mds-icon>
    </button>
</template>

<script>
import MdsIcon from "./Icon";
import MdsInput from "./Input";
export default {
    name: "mds-button",
    components: {
        MdsIcon,
        MdsInput
    },
    props: {
        ariaDescribedby: String, // TBD
        checked: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        href: String,
        icon: String,
        iconRight: String,
        id: String,
        name: String,
        size: {
            type: String,
            default: "medium",
            validator: function(value) {
                return ["small", "medium", "large"].indexOf(value) !== -1;
            }
        },
        text: {
            type: String,
            default: ""
        },
        type: {
            type: String,
            default: "submit",
            validator: function(value) {
                return ["button", "reset", "submit", "checkbox", "radio"].indexOf(value) !== -1;
            }
        },
        value: String,
        variation: {
            type: String,
            default: "primary",
            validator: function(value) {
                return ["primary", "secondary", "flat", "icon-only"].indexOf(value) !== -1;
            }
        }
    },
    computed: {
        ariaLabel() {
            if (this.isIconOnly) {
                return this.text;
            }
            return undefined;
        },
        buttonClasses() {
            return {
                [`mds-button--${this.size}`]: this.size !== "medium",
                [`mds-button--${this.variation}`]: this.variation !== ""
            };
        },
        iconClasses() {
            return {
                "mds-button__icon": true,
                "mds-button--flat-icon-m": this.size === "medium" && this.variation === "flat"
            };
        },
        hasHref() {
            return typeof this.href !== "undefined" && this.href !== "";
        },
        hasIcon() {
            return this.hasLeftIcon || this.hasRightIcon;
        },
        hasLeftIcon() {
            return typeof this.icon !== "undefined" && this.icon !== "";
        },
        hasRightIcon() {
            return typeof this.iconRight !== "undefined" && this.iconRight !== "";
        },
        isRadio() {
            return this.type === "radio";
        },
        isCheckBox() {
            return this.type === "checkbox";
        },
        isIconOnly() {
            return this.variation === "icon-only";
        }
    },
    methods: {
        buttonClickHandler(e) {
            this.$emit("click", e);
        }
    }
};
</script>
